import React from "react";
import styles from "./ReferralCard.module.scss";
import classNames from "classnames";
import { Link } from "react-router-dom";
import Icon from "@/shared/components/Icon/Icon";
import useUserEmail from "@/shared/hooks/useUserEmail";

interface ReferralCardProps {
  className?: string;
}

const ReferralCard: React.FC<ReferralCardProps> = ({ className }) => {
  const userEmail = useUserEmail();
  const ctaURL = `/mein-remindme/freunde-werben-freunde?email=${userEmail}&autoDetect=1`;
  return (
    <div className={classNames(styles.RAFCardContainer, className)}>
      <div className={styles.content}>
        <div className={styles.title}>Freunde werben und je 25 € BestChoice-Premium-Gutschein sichern</div>
        <div className={styles.description}>
          <span className={styles.regularText}>
            Empfehlen Sie unseren kostenlosen Wechselservice an Ihre Freunde und Familie weiter – und sichern Sie sich
            und Ihren Liebsten{" "}
          </span>
          <span className={styles.boldText}>jeweils einen 25 € BestChoice-Premium-Gutschein</span>
          <span className={styles.regularText}> als Dankeschön!</span>
        </div>
        <div className={styles.buttonContainer}>
          <Link to={ctaURL} className={classNames(styles.buttonContent)}>
            <div className={styles.buttonText}>Jetzt Freunde werben</div>
            <Icon className={classNames(styles.arrow)} name={"arrowRight"} />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ReferralCard;
